import React, { useState } from "react";
import axios from "axios";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
import Forecast from "./Forecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ready: false});
  const [city, setCity] = useState(props.defaultCity);

  function displayWeather(response) {
    setWeatherData({
      ready: true,
      city: response.data.name,
      coordinates: response.data.coord,
      date: new Date(response.data.dt * 1000),
      temperature: Math.round(response.data.main.temp),
      description: response.data.weather[0].description,
      humidity: response.data.main.humidity,
      wind: Math.round(response.data.wind.speed),
      icon: response.data.weather[0].icon,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

 function search() {
    const apiKey = "41a8abefdebf6438427080d42e493299";
    const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(displayWeather);
  }

  if (weatherData.ready) {
    return (
<div className="card-body">
            <form onSubmit={handleSubmit}  className="row">
              <div className="col-9">
                <input
                  type="search"
                  placeholder="Type a city"
                  className="form-control"
                  autoFocus="on"
                  onChange={updateCity}
                />
              </div>
              <div className="col-3">
                <input type="submit" value="Search" className="btn btn-danger" />
              </div>
            </form>
  <p className="day-time">
    <FormattedDate date={weatherData.date} />
  </p>
      <h2 className="city">{weatherData.city}</h2>

        <div className="row align-items-center">
         
          <div className="col">
            < WeatherTemperature celcius={weatherData.temperature} />
          </div>
         
          <div className="col">
           <WeatherIcon code={weatherData.icon} size={64} />
           <p className="description">{weatherData.description}</p>
          </div>

          <div className="col">
            <ul className="weather-details">
              <br />
              <li>Humidity: <span>{weatherData.humidity}</span>%</li>
              <li>Wind: <span>{weatherData.wind}</span> km/h</li>
            </ul>
        </div>
        <Forecast coordinates={weatherData.coordinates} />
        </div>  
          </div>
  );

  } else {
    search();
   return "Loading...";
  }
}
